import api from '@/api'
import { defineStore } from 'pinia'
import PayMethodStatus from '@/const/finance/PayMethodStatus'

export const usePayMethodStore = defineStore('payMethod', {
  state: () => ({
    customOfflinePayMethods: null, // 已启用的自定义线下支付方式
    allCustomOfflinePayMethods: null // 所有自定义线下支付方式
  }),

  actions: {
    /**
     * 获取自定义线下支付方法列表
     */
    async getCustomOfflinePayMethods() {
      try {
        const { data } = await api.customOfflinePayMethods.getCustomOfflinePayMethods()
        this.allCustomOfflinePayMethods = data
        const customOfflinePayMethods = data.filter(
          (payMethod) => payMethod.status === PayMethodStatus.STATUS_ENABLE
        )
        this.customOfflinePayMethods = customOfflinePayMethods
      } catch (e) {
        console.error('获取自定义线下支付方法列表失败', e)
      }
    }
  }
})
